// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import {Turbo} from "@hotwired/turbo-rails"

import * as ActiveStorage from "@rails/activestorage"
import { handleTurboFrameMissing } from "./turbo_frame_missing_handler"

ActiveStorage.start()

Turbo.StreamActions.visit = function () {
    Turbo.visit(this.target, { frame: this.frame })
}

document.addEventListener("turbo:frame-missing", handleTurboFrameMissing)
